import {
    absoluteBottomRight,
    colors,
    flex,
    radii,
    spacing,
    type,
} from '../../OpportunityWorkspace.style';

export const root = {
    ...flex.row,
    alignItems: 'flex-start',
    position: 'relative',
    gap: 16,
    padding: spacing.bannerPadding,
    boxSizing: 'border-box',
    backgroundColor: colors.overviewTintBg,
    border: colors.overviewTintBorder,
    borderRadius: radii.banner,
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
};

/** Viewports below MUI `lg` (1280px)—e.g. 1200px-wide layouts */
export const rootBelowLg = {
    gap: 12,
    padding: '12px 16px',
};

export const decorImage = {
    width: 50,
    height: 65,
    ...absoluteBottomRight,
};

export const leadIcon = {
    width: 56,
    height: 56,
    flexShrink: 0,
    objectFit: 'contain',
    display: 'block',
};

export const textColumn = {
    ...flex.col,
    gap: 8,
    minWidth: 0,
    flex: 1,
};

export const titleStyle = type.overviewTitle;

export const subtitleStyle = type.overviewSubtitle;
